/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from "../runtime";
import type { UserActionLogDto } from "../models/index";
import {
    UserActionLogDtoFromJSON,
    UserActionLogDtoToJSON,
} from "../models/index";

/**
 *
 */
export class UserActionLogHttpFunctionsApi extends runtime.BaseAPI {
    /**
     * Query user action log. Requires Permission.user_tasks_read
     */
    async userActionLogsODataRaw(
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<Array<UserActionLogDto>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/user-action-logs-odata`,
                method: "GET",
                headers: headerParameters,
                query: queryParameters,
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            jsonValue.map(UserActionLogDtoFromJSON),
        );
    }

    /**
     * Query user action log. Requires Permission.user_tasks_read
     */
    async userActionLogsOData(
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<Array<UserActionLogDto>> {
        const response = await this.userActionLogsODataRaw(initOverrides);
        return await response.value();
    }
}
